import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireCompany = true }) {
  const { user, companies } = useApp();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireCompany && companies.length === 0) return <Navigate to="/onboarding" replace />;
  return children;
}
